import type { TypographyVariantsOptions } from '@mui/material';

export const typography: TypographyVariantsOptions = {
  // fontFamily: '"Geist", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
  giant: {
    fontSize: '64px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '72px',
  },

  header: {
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '40px',
  },

  title_accent_18_32: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
  },
  title_accent_18_18: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
  },
  title: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
  },
  body_14_24: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  body_14_20: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },
  subtitle_14_24: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
  },
  subtitle_14_20: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
  },
  subtitle_alt: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  small_description: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  button: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
    textTransform: 'uppercase',
  },

};